import { jsx as _jsx } from "react/jsx-runtime";
import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { withPlanInfo } from '../../../components/hoc/WithPlanInfo';
import { FileReport } from './FileReport';
import { withAutoFixSuggestionsModal } from './AutoFixesSuggestionsModal';
class Report extends Component {
    constructor() {
        super(...arguments);
        this.state = {
            expandedIssues: {},
            copiedFilePath: false,
        };
        this.toggleIssueDocs = (blockIndex, nodeIndex, messageIndex) => {
            const { expandedIssues } = this.state;
            const nodeId = `${blockIndex}#${nodeIndex}`;
            const exists = Object.prototype.hasOwnProperty.call(expandedIssues, nodeId) &&
                // @ts-expect-error TS7053: Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{}'.
                Array.isArray(expandedIssues[nodeId]) &&
                // @ts-expect-error TS7053: Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{}'.
                expandedIssues[nodeId].includes(messageIndex);
            if (exists) {
                this.setState({
                    expandedIssues: {
                        ...expandedIssues,
                        // @ts-expect-error TS7053: Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{}'.
                        [nodeId]: expandedIssues[nodeId].filter((index) => index !== messageIndex),
                    },
                });
            }
            else {
                this.setState({
                    expandedIssues: {
                        ...expandedIssues,
                        [nodeId]: Object.prototype.hasOwnProperty.call(expandedIssues, nodeId)
                            // @ts-expect-error TS7053: Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{}'.
                            ? [...expandedIssues[nodeId], messageIndex]
                            : [messageIndex],
                    },
                });
            }
        };
        this.handleClickOnFilePath = (filePath) => {
            navigator.clipboard.writeText(filePath);
            this.setState({ copiedFilePath: true });
            setTimeout(() => {
                this.setState({ copiedFilePath: false });
            }, 5000);
        };
    }
    render() {
        const { file, generated, hiddenType, isRepositoryPrivate, proPlan, coveredLines, onLoadClick, fileIndex, browser, showAutoFixesClick, } = this.props;
        return _jsx(FileReport, { file: file, generated: generated, fileIndex: fileIndex, copiedFilePath: this.state?.copiedFilePath, expandedIssues: this.state.expandedIssues, proPlan: proPlan, isRepositoryPrivate: isRepositoryPrivate, hiddenType: hiddenType, coveredLines: coveredLines, showAutoFixesClick: showAutoFixesClick, onLoadClick: onLoadClick, onFilePath: this.handleClickOnFilePath, onToggleIssueDocs: this.toggleIssueDocs, browser: browser });
    }
}
Report.defaultProps = {
    generated: false,
    copiedFilePath: false,
};
const mapStateToProps = (state) => ({
    browser: state.browser,
});
export default withAutoFixSuggestionsModal(withPlanInfo(connect(mapStateToProps)(withTranslation()(Report))));
